module.exports = __webpack_public_path__ + "img/13.1d4107ce.png";